export default "__VITE_ASSET__S1waVBgC__"